import { render } from "./InvoiceForm.vue?vue&type=template&id=34cd6c2e&ts=true"
import script from "./InvoiceForm.vue?vue&type=script&lang=ts"
export * from "./InvoiceForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__